export default "__VITE_ASSET__ac538e6c__"